/* eslint-disable import/no-named-as-default-member */
import { Dialog, DialogContent, IconButton, Select, MenuItem, Tooltip, InputLabel, FormControl, CircularProgress } from "@material-ui/core";
import React, { Component } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import styled from "styled-components";
import numberFormatter from 'utils/numberFormatter';
import CloseIcon from "@material-ui/icons/Close";
import { FileDownload } from "@material-ui/icons";
import { VersitileInput } from "components/Global/Fields/VersitileInput";
import { PrimaryButton, SecondaryButton } from "components/Global/Buttons";
import { exportWhatIf, getWhatIfInfo, clearWhatIfInfo } from "store/state/deal";
import dealViewMetric from "constants/screenElements/dealViewMetric";
import {getConfigItemByParentId} from 'store/state/configItems';
import { SISENSE_REPORT_DASHBOARDS, SISENSE_REPORT_WIDGETS, CONFIGURABLE_URLS } from "constants/configItemParents";

const LOANBOSS_BLUE = "#2196f3";

const availableMetrics = [
{label: "Cap Rate", fieldName: "capRate"},
// {label: "Cash Out", fieldName: "cashOut"},
// {label: "Cushion", fieldName: "cushion"},
{label: "Debt Yield", fieldName: "debtYield"},
{label: "DSCR", fieldName: "dscr"},
{label: "LTV", fieldName: "ltv"},
{label: "Loan Balance", fieldName: "loanBalance"},
{label: "Loan Proceeds", fieldName: "loanProceeds"},
{label: "Market Value", fieldName: "marketValue"},
{label: "NOI (Actual)", fieldName: "noiActual"},
{label: "NOI (Lender)", fieldName: "noiLender"},
{label: "Occupancy", fieldName: "occupancy"},
{label: "Prepayment Penalty", fieldName: "prepaymentPenalty"},
{label: "Principal", fieldName: "principal"},
{label: "Recourse", fieldName: "recourse"},
// {label: "Supplemental Loan", fieldName: "supplementalLoan"},
{label: "WAIR", fieldName: "weightedAverageInterestRate"},
]

const StyledDialogIconButton = styled(IconButton)`
  && {
    position: absolute;
    top: 8px;
    right: 13px;
  }
`;

const StyledDialog = styled(Dialog)`
  &&& {
    min-width: 700px;
  }
`;

const StyledDialogContent = styled(DialogContent)`
  && {
    padding: 28px, 28px, 0px, 28px;
    min-height: 350px;
    overflow-x: hidden;
    overflow-y: auto;
  }
`;

const ModalTitle = styled.p`
  font-weight: normal;
  font-size: 17pt;
  margin-left: 20px;
`;

const scenarios = [
  "Market Expectations",
  "Parallel Shift",
  "Standard Deviation",
];

const StyledTableHead = styled.th`
  min-width: 120px;
  padding-bottom: 8px;
  border-bottom: 1px solid #999999;
`;

const StyledTableCell = styled.td`
  min-width: 120px;
  padding-top: 7px;
  text-align: center;
`;
 const StyledResultsGrid = styled.div`
  overflow-x: scroll;
  overflow-y: scroll;
  height: 480px;
 `;

class WhatIfModal extends Component {

  componentDidMount() {
    this.props.getConfigItemByParentId({
      id: SISENSE_REPORT_DASHBOARDS
    });
    this.props.getConfigItemByParentId({
      id: SISENSE_REPORT_WIDGETS
    });
    this.props.getConfigItemByParentId({
      id: CONFIGURABLE_URLS
    });
  }

  componentDidUpdate(prevProps) {
    if(!prevProps.whatIfInfo && this.props.whatIfInfo && (this.props.whatIfInfo.gridResults || !this.props.whatIfInfo.success)) {
      this.setState({
        tableData: this.props.whatIfInfo.gridResults ? this.props.whatIfInfo.gridResults : [],
        updatePressed: false
      });
    }
  }

  state = {
    noiAdj: null,
    capRateAdj: null,
    scenario: scenarios[0],
    parallelShiftAmount: null,
    standardDeviations: null,
    updatePressed: false,
    tableOverride: true,
    selectedSrQuote: null,
    selectedSuppQuote: null,
    leftAxis: null,
    rightAxis: null,
    tableData: [{},{},{},{},{},{},{},{},{},{},{},{},{},{},{}], //placeholder
    hasRunFirstTimeUpdate: false,
  }

  getCurrentNOI = () => {
    const {scope} = this.props;
    if (scope === "deal"){
      let metricItem = this.props.dealState.metricData.filter(x=>x.metricId===dealViewMetric.map.NOI)[0];
      if(!metricItem) return "--"
      if(!metricItem.decimalValue) return "-"
      return `${numberFormatter.formatMoney(metricItem.decimalValue)}`;
    }
  }

  getCurrentCapRate = () => {
    const {scope} = this.props;
    if (scope === "deal"){
      let metricItem = this.props.dealState.metricData.filter(x=>x.metricId===dealViewMetric.map.CAP_RATE)[0];
      if(!metricItem) return "--"
      if(!metricItem.decimalValue) return "-"
      return `${(metricItem.decimalValue*100).toFixed(2)}%`;
    }
  }

  handleDownload = () => {
    this.props.exportWhatIf({
      tableData: this.state.tableData,
    })
  }

  renderTable = () => {
    return (
      <table style = {{borderCollapse: "collapse", marginTop:"20px"}}>
        {this.renderTableHeads()}
        {this.renderTableRows()}
      </table>
    )
  }

  renderTableHeads = () => {
    let out = [<StyledTableHead>Date</StyledTableHead>];
    availableMetrics.forEach(metric => {
      out.push(<StyledTableHead>{metric.label}</StyledTableHead>)
    });
    return out;
  }

  renderTableRows = () => {
    let out = [];
    let records = this.state.tableData;
    if(records.length === 0) records = [{},{},{},{},{},{},{},{},{},{},{},{},{},{},{}]; //render empty table if there are no records
    records.forEach(record => {
      out.push(this.renderTableRowForRecord(record));
    })
    return out;
  }

  renderTableRowForRecord = (record) =>{
    let cells = [<StyledTableCell>{record.periodDate || "-"}</StyledTableCell>];
    availableMetrics.forEach(metric => {
      cells.push(<StyledTableCell>{record[metric.fieldName] || "-"}</StyledTableCell>);
    })
    return <tr>{cells}</tr>
  }

  renderGraph = () => {
    const { whatIfInfo, sisenseURL } = this.props;
    if (whatIfInfo == null || whatIfInfo.length === 0 || !sisenseURL)
      return null;
      
    const filter = `filter=${whatIfInfo[ 0 ].requestId}`;
    const iframeSource = `https://${sisenseURL}/app/main#/dashboards/${this.props.dashboardId}/widgets/${this.props.widgetId}?embed=true&l=true&${filter}`
    return (<div style={{ textAlign: "center", minHeight: "500px" }}>
      <iframe title="sisense" id="ifm" name="ifm" width="100%" height="500px" frameborder="0" src={iframeSource} scrolling="auto"></iframe>
    </div>);
  }

  lightOrDarkGrey = (value) => {
    return value ? "#555555" : "#aaaaaa";
  }

  getShockTypeForCalculator = () => {
    switch (this.state.scenario) {
      case "Parallel Shift": 
        return "PARALLEL";
      case "Market Expectations":
        return "MARKET_EXPECTATIONS";
      case "Standard Deviation":
        return "STANDARD_DEVIATION";
    }
  }

  getShockValue = () => {
    switch (this.state.scenario) {
      case "Parallel Shift": 
        return this.state.parallelShiftAmount || 0;
      case "Market Expectations":
        return 0;
      case "Standard Deviation":
        return this.state.standardDeviations || 0;
    }
  }

  handleUpdate = () => {
    let payload = {
      capRate: this.state.capRateAdj ? this.state.capRateAdj / 100 : 0,
      noiAdjustment: this.state.noiAdj ? this.state.noiAdj / 100 : 0,
      shockType: this.getShockTypeForCalculator(),
      shockValue: this.getShockValue(),
    };
    switch(this.props.scope) {
      case "deal":
      case "pipelineDeal":
        payload.dealId = this.props.dealId;
        break;;
      case "fund":
        payload.groupId = this.props.fundId;
        break;
      case "portfolio":
        payload.companyId = this.props.authentication.user.contact.companyId;
        break;
    }
    this.props.getWhatIfInfo(payload);
    if(this.props.scope === "pipeline"){
      payload.selectedSrQuote = this.state.selectedSrQuote;
      payload.selectedSuppQuote = this.state.selectedSuppQuote;
    }

    // this.props.getWhatIfCalculation(payload)

    this.setState({updatePressed: true});
  }

  isProTier = () =>{
    if(this.props.authentication){
        return this.props.authentication.companyLevel==="Professional"
        || this.props.authentication.companyLevel==="Enterprise"
        || this.props.authentication.companyLevel==="Secondary Sponsor"
    }else{
      return false;
    }
  }

  renderMetricOptions = () => {
    let out = [];
    availableMetrics.forEach(metric => {
      out.push(<MenuItem value={metric.label}>{metric.label}</MenuItem>)
    })
    return out;
  }

  renderGraphOrTable = () => {
    return (
      <div style={{paddingTop: "20px", width: "100%", verticalAlign: "top"}}>
        {/*{this.isProTier() && !this.state.tableOverride && <>
          <span style={{color: "#999999", fontSize: "15pt"}}>METRICS</span>
           <br/><br/>
          <FormControl>
            <InputLabel shrink htmlFor="Left Axis">Left Axis</InputLabel>
            <Select
              style = {{minWidth: "150px", marginRight: "20px"}}
              value = {this.state.leftAxis}
              onChange = {(event) => this.setState({leftAxis: event.target.value})}
              name = "Left Axis"
            >
              {this.renderMetricOptions()}
            </Select>
          </FormControl>
          <FormControl>
            <InputLabel shrink htmlFor="Right Axis">Right Axis</InputLabel>
            <Select
              style = {{minWidth: "150px", marginRight: "20px"}}
              value = {this.state.rightAxis}
              onChange = {(event) => this.setState({rightAxis: event.target.value})}
              name = "Right Axis"
            >
              {this.renderMetricOptions()}
            </Select>
          </FormControl> 
          {<div hidden={!this.isProTier() || this.state.tableOverride}>
            {this.renderGraph()}
          </div> }
        </>}*/}
        {(!this.isProTier() || this.state.tableOverride) && <StyledResultsGrid>
          {this.renderTable()}
        </StyledResultsGrid>}
      </div>
    )
  }

  cleanClose = () => {
    this.props.clearWhatIfInfo(); //this just clears out the state after the modal is closed
    this.props.handleClose();
  }

  render() {
    const { isOpen, seniorLoans, mezzLoans } = this.props;
    if(isOpen && !this.state.hasRunFirstTimeUpdate) {
      this.setState({hasRunFirstTimeUpdate: true});
      this.handleUpdate();
    }
    return (
      <StyledDialog
        modal
        maxWidth="lg"
        open={isOpen}
        autoDetectWindowHeight={false}
        autoScrollBodyContent={false}
        onClose={() => this.cleanClose()}
      >
        <ModalTitle>What If Calculator</ModalTitle>
        <StyledDialogIconButton onClick={() => this.cleanClose()}>
          <CloseIcon id="closeIcon" style={{ fontSize: 22 }} />
        </StyledDialogIconButton>
        <StyledDialogContent style = {{maxWidth: "1250px", overflow: "auto"}}>


        {this.props.scope === "pipelineDeal" && 
          (<div style = {{paddingBottom: "30px"}}>
            <div style={{display: "inline-block", width: "300px", marginRight: "10px"}}>
              <span style={{fontSize: "10pt"}}>Sr. Quotes</span>
              <br/>
              <Select 
                style={{backgroundColor: "white", width: "300px"}}
                value={this.state.selectedSrQuote}
                onChange={event => { this.setState({selectedSrQuote: event.target.value}); }} >
                {this.renderQuoteMenuItems(seniorLoans)}
              </Select>
            </div>
            {mezzLoans && mezzLoans.length > 0 && 
              (<div style={{display: "inline-block", width: "300px"}}>
              <span style={{fontSize: "10pt"}}>Supp Quotes</span>
              <br/>
              <Select 
                style={{backgroundColor: "white", width: "300px"}}
                value={this.state.selectedSuppQuote}
                onChange={event => { this.setState({selectedSuppQuote: event.target.value}); }} >
                {this.renderQuoteMenuItems(mezzLoans)}
              </Select>
            </div>)}
          </div>)}

          <div style = {{borderBottom: "1px solid #999999", paddingBottom: "30px"}}>
            <VersitileInput 
              internalLabel = "NOI Adj. (Optional)"
              helperTextColor = "black"
              labelColor = {this.lightOrDarkGrey(this.state.noiAdj)}
              type = "percentNoDecimal"
              value = {this.state.noiAdj}
              onChange = {value=>this.setState({noiAdj: value})}
              style = {{marginRight: "40px"}}
              helperText = {this.props.scope==="deal" ? `Current NOI: ${this.getCurrentNOI()}` : ""}
            />
            <VersitileInput
              internalLabel = "Cap Rate (Optional)"
              helperTextColor = "black"
              labelColor = {this.lightOrDarkGrey(this.state.capRateAdj)}
              type = "percent"
              value = {this.state.capRateAdj}
              onChange = {value=>this.setState({capRateAdj: value})}
              helperText = {this.props.scope==="deal" ? `Current Cap Rate: ${this.getCurrentCapRate()}` : ""}
            />
            <div style={{display: "inline-block", marginLeft: "40px", marginRight: "40px"}}>
              <span style={{fontSize: "10pt"}}>Rate Environment</span>
              <br/>
              <Select 
                style = {{backgroundColor: "white", minWidth: "150px"}}
                value = {this.state.scenario}
                onChange = {event => {
                    this.setState({scenario: event.target.value});
                }}
              >
                {this.renderScenarioMenuItems()}
              </Select>
            </div>
            {this.renderExtraInput()}
            <div style = {{display: "inline-block", float: "right", marginTop: "20px"}}>
              <PrimaryButton style = {{marginTop: "-10px"}} onClick = {this.handleUpdate} disabled={this.state.updatePressed}>Update</PrimaryButton>
                {this.renderExcelButton()}
             </div>
        </div>
        {/* {this.isProTier() &&
          <div style={{display:"inline-block", float: "right", marginTop: "25px", verticalAlign: "center"}}>
            <Tooltip title={"Change View"}>
            <Repeat
              style = {{color: LOANBOSS_BLUE, cursor: "pointer"}}
              onClick = {()=>this.setState({tableOverride: !this.state.tableOverride})}
            />
            </Tooltip>
          </div>
        } */}
          {this.renderGraphOrTable()}
        </StyledDialogContent>
      </StyledDialog>
    );
  }

  renderExcelButton = () => {
    if(this.state.updatePressed && !this.props.whatIfInfo) {
      return <div style= {{display: "inline-block",  marginLeft: "10px"}} ><CircularProgress size={"30px"}/></div>
    } else if (!this.state.updatePressed && this.props.whatIfInfo) {
      return <SecondaryButton onClick = {this.handleDownload}><FileDownload/>Excel</SecondaryButton>
    } else 
      return null;
  }

  renderExtraInput = () => {
    switch(this.state.scenario) {
      case "Parallel Shift":
      return (
        <VersitileInput
          type = "integer"
          internalLabel = "Parallel Shift (bps)"
          value = {this.state.parallelShiftAmount}
          labelColor = {this.lightOrDarkGrey(this.state.parallelShiftAmount)}
          onChange = {(value => this.setState({parallelShiftAmount: value}))}
        />
      )
      case "Standard Deviation":
        return (
          <VersitileInput
            type = "integer"
            internalLabel = "Standard Deviations"
            value = {this.state.standardDeviations}
            labelColor = {this.lightOrDarkGrey(this.state.standardDeviations)}
            onChange = {(value => this.setState({standardDeviations: value}))}
          />
        )
    }
  }

  renderScenarioMenuItems = () => {
    let out = [];
    scenarios.forEach(scenario => {
      out.push(
        <MenuItem value={scenario}>{scenario}</MenuItem>
      )
    });
    return out;
  }
  renderQuoteMenuItems = (quotes) => {
    let out = [];
    quotes.forEach(quote => {
      out.push(
        <MenuItem value={quote.id}>{quote.label}</MenuItem>
      )
    });
    return out;
  }
}

const mapStateToProps = ({ authentication, deal, configItems }) => {
  return {
    authentication,
    dealState: deal,
    whatIfInfo: deal.whatIfInfo,
    dashboardId: configItems && 
      configItems.configItemByParent[ SISENSE_REPORT_DASHBOARDS ] &&
      configItems.configItemByParent[ SISENSE_REPORT_DASHBOARDS ].filter(x => x.id === "12ffa36b-b2f0-436b-a0b6-844a78cd1ccb").length > 0 ?
      configItems.configItemByParent[ SISENSE_REPORT_DASHBOARDS ].filter(x => x.id === "12ffa36b-b2f0-436b-a0b6-844a78cd1ccb")[ 0 ].value : "",

    widgetId: configItems && 
      configItems.configItemByParent[ SISENSE_REPORT_WIDGETS ] &&
      configItems.configItemByParent[ SISENSE_REPORT_WIDGETS ].filter(x => x.id === "dc9f1917-6e18-4780-8e69-8c5bde0ac213").length > 0 ?
      configItems.configItemByParent[ SISENSE_REPORT_WIDGETS ].filter(x => x.id === "dc9f1917-6e18-4780-8e69-8c5bde0ac213")[ 0 ].value : "",

    sisenseURL: configItems &&
      configItems.configItemByParent[ CONFIGURABLE_URLS ] &&
      configItems.configItemByParent[ CONFIGURABLE_URLS ].filter(x => x.id === "fb26de17-1ccd-11ed-a0f6-027736c5c5ef").length > 0 ?
      configItems.configItemByParent[ CONFIGURABLE_URLS ].filter(x => x.id === "fb26de17-1ccd-11ed-a0f6-027736c5c5ef")[ 0 ].value : ""
  };
}

export default compose(
  connect(mapStateToProps, {
    exportWhatIf,
    getWhatIfInfo,
    getConfigItemByParentId,
    clearWhatIfInfo,
  })
)(WhatIfModal);
